import { __assign, __read, __spread, __values } from "tslib";
import { app } from '@ekuaibao/whispered';
import { getFirstScreenRoute } from './initRoute';
import { enableFMPOptimization } from '../lib/featbit';
export var FMP_CRITICAL_MFES = {
    '/new-homepage': ['@ekuaibao/plugin-web-main-domain', '@ekuaibao/plugin-web-home-domain'],
    '/bills': ['@ekuaibao/plugin-web-main-domain'],
    '/audit/approve': ['@ekuaibao/plugin-web-main-domain'],
};
export function getCriticalMfeNames(route) {
    var e_1, _a;
    try {
        for (var _b = __values(Object.keys(FMP_CRITICAL_MFES)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var prefix = _c.value;
            if (route === prefix) {
                return FMP_CRITICAL_MFES[prefix];
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return null;
}
export var hostFmpDebug = function (message, extra) {
    if (!enableFMPOptimization())
        return;
    var route = getFirstScreenRoute();
    if (!['/bills', '/new-homepage', '/audit/approve'].includes(route)) {
        return;
    }
    var prefix = '[pc-fmp-optimization][host]';
    var payload = {
        route: route,
        t: Math.round(performance.now())
    };
    if (extra === undefined) {
        console.info(prefix, message, payload);
        return;
    }
    console.info(prefix, message, __assign(__assign({}, payload), extra));
};
export var _isDeferredPhase = false;
export var _deferredLoadStatus = 'idle';
var _deferredReadyResolve = null;
export var _deferredReadyPromise = new Promise(function (resolve) {
    _deferredReadyResolve = resolve;
});
export function setDeferredPhase(isDeferred) {
    _isDeferredPhase = isDeferred;
}
export function setDeferredLoadStatus(status) {
    _deferredLoadStatus = status;
}
export function resolveDeferredReadyOnce() {
    if (!_deferredReadyResolve) {
        return;
    }
    _deferredReadyResolve();
    _deferredReadyResolve = null;
}
var _criticalRoutePrefixes = new Set();
export function initCriticalRoutePrefixes(criticalMfeNames) {
    _criticalRoutePrefixes.clear();
    Object.entries(FMP_CRITICAL_MFES)
        .filter(function (_a) {
        var _b = __read(_a, 2), mfes = _b[1];
        return mfes.some(function (m) { return criticalMfeNames.has(m); });
    })
        .map(function (_a) {
        var _b = __read(_a, 1), routePrefix = _b[0];
        return routePrefix;
    })
        .forEach(function (prefix) { return _criticalRoutePrefixes.add(prefix); });
}
export function isRouteBlocked(target) {
    var e_2, _a;
    if (_deferredLoadStatus !== 'loading')
        return false;
    var targetPath = target.split('?')[0];
    try {
        for (var _criticalRoutePrefixes_1 = __values(_criticalRoutePrefixes), _criticalRoutePrefixes_1_1 = _criticalRoutePrefixes_1.next(); !_criticalRoutePrefixes_1_1.done; _criticalRoutePrefixes_1_1 = _criticalRoutePrefixes_1.next()) {
            var prefix = _criticalRoutePrefixes_1_1.value;
            if (targetPath === prefix || targetPath.startsWith(prefix + '/'))
                return false;
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_criticalRoutePrefixes_1_1 && !_criticalRoutePrefixes_1_1.done && (_a = _criticalRoutePrefixes_1.return)) _a.call(_criticalRoutePrefixes_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return true;
}
var _navigationHintTimer = null;
var _navigationHintEl = null;
export function ensureNavigationHintStyle() {
    if (document.getElementById('fmp-navigation-loading-style')) {
        return;
    }
    var style = document.createElement('style');
    style.id = 'fmp-navigation-loading-style';
    style.textContent = "\n    @keyframes fmp-navigation-progress {\n      0% { transform: translateX(-100%); }\n      100% { transform: translateX(300%); }\n    }\n    .fmp-navigation-loading {\n      position: fixed;\n      left: 0;\n      top: 0;\n      width: 100%;\n      height: 2px;\n      z-index: 9999;\n      pointer-events: none;\n      overflow: hidden;\n      background: rgba(22, 119, 255, 0.12);\n    }\n    .fmp-navigation-loading::after {\n      content: '';\n      position: absolute;\n      left: 0;\n      top: 0;\n      width: 30%;\n      height: 100%;\n      background: #1677ff;\n      animation: fmp-navigation-progress 0.9s linear infinite;\n    }\n  ";
    document.head.appendChild(style);
}
export function showNavigationHint() {
    if (_navigationHintEl)
        return;
    ensureNavigationHintStyle();
    var el = document.createElement('div');
    el.className = 'fmp-navigation-loading';
    _navigationHintEl = el;
    document.body.appendChild(el);
}
export function hideNavigationHint() {
    if (_navigationHintTimer !== null) {
        clearTimeout(_navigationHintTimer);
        _navigationHintTimer = null;
    }
    if (_navigationHintEl) {
        _navigationHintEl.remove();
        _navigationHintEl = null;
    }
}
export function guardedAction(action, hint) {
    if (hint === void 0) { hint = '正在加载能力，请稍候...'; }
    if (_deferredLoadStatus === 'succeeded') {
        action();
        return;
    }
    console.info('[FMP] guardedAction: deferred not ready, queuing action');
    showNavigationHint();
    _deferredReadyPromise.then(function () {
        hideNavigationHint();
        action();
    });
}
var _deferredCallQueue = [];
export function installServiceProxy() {
    var originalApply = app.apply.bind(app);
    app.apply = function proxyApply(id, fnName) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        try {
            return originalApply.apply(app, [id, fnName].concat(args));
        }
        catch (e) {
            if (_isDeferredPhase && e instanceof Error && /not found|do not exist/.test(e.message)) {
                console.warn("[FMP] Service call queued: plugin<" + id + ">." + fnName);
                return new Promise(function (resolve, reject) {
                    _deferredCallQueue.push({ id: id, fnName: fnName, args: args, resolve: resolve, reject: reject });
                });
            }
            throw e;
        }
    };
    return function () {
        ;
        app.apply = originalApply;
    };
}
export function replayDeferredCalls() {
    var e_3, _a;
    if (_deferredCallQueue.length === 0)
        return;
    console.info("[FMP] Replaying " + _deferredCallQueue.length + " deferred service calls");
    var calls = _deferredCallQueue.splice(0, _deferredCallQueue.length);
    try {
        for (var calls_1 = __values(calls), calls_1_1 = calls_1.next(); !calls_1_1.done; calls_1_1 = calls_1.next()) {
            var _b = calls_1_1.value, id = _b.id, fnName = _b.fnName, args = _b.args, resolve = _b.resolve, reject = _b.reject;
            try {
                var result = app.apply.apply(app, [id, fnName].concat(args));
                resolve(result);
            }
            catch (e) {
                console.warn("[FMP] Replay failed: plugin<" + id + ">." + fnName, e);
                reject(e);
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (calls_1_1 && !calls_1_1.done && (_a = calls_1.return)) _a.call(calls_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
}
export var _pendingNavigation = null;
var NAVIGATION_HINT_DELAY = 200;
export function queuePendingNavigation(action, target, type) {
    _pendingNavigation = { action: action, target: target, type: type };
    if (_navigationHintTimer === null && !_navigationHintEl) {
        _navigationHintTimer = window.setTimeout(function () {
            _navigationHintTimer = null;
            showNavigationHint();
        }, NAVIGATION_HINT_DELAY);
    }
    hostFmpDebug('navigation queued until deferred ready', { target: target, type: type });
}
export function flushPendingNavigation() {
    var pending = _pendingNavigation;
    _pendingNavigation = null;
    hideNavigationHint();
    if (!pending)
        return;
    hostFmpDebug('replay pending navigation', {
        target: pending.target,
        type: pending.type,
        deferredLoadStatus: _deferredLoadStatus
    });
    pending.action();
}
export function extractNavigationTarget(to) {
    if (typeof to === 'string')
        return to;
    if (to && typeof to === 'object') {
        var pathname = to.pathname || '';
        var search = to.search || '';
        var hash = to.hash || '';
        return "" + pathname + search + hash;
    }
    return '';
}
export function shouldQueueNavigation(target) {
    if (!_isDeferredPhase || _deferredLoadStatus !== 'loading')
        return false;
    if (!target || !target.startsWith('/'))
        return false;
    return isRouteBlocked(target);
}
export function installNavigationGuard() {
    var _a, _b;
    var history = app.history;
    if (!history || history.__fmpNavigationGuardInstalled) {
        return function () { };
    }
    var originalPush = (_a = history.push) === null || _a === void 0 ? void 0 : _a.bind(history);
    var originalReplace = (_b = history.replace) === null || _b === void 0 ? void 0 : _b.bind(history);
    if (!originalPush || !originalReplace) {
        return function () { };
    }
    history.__fmpNavigationGuardInstalled = true;
    history.push = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var target = extractNavigationTarget(args[0]);
        if (!shouldQueueNavigation(target)) {
            return originalPush.apply(void 0, __spread(args));
        }
        queuePendingNavigation(function () { return originalPush.apply(void 0, __spread(args)); }, target, 'push');
    };
    history.replace = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var target = extractNavigationTarget(args[0]);
        if (!shouldQueueNavigation(target)) {
            return originalReplace.apply(void 0, __spread(args));
        }
        queuePendingNavigation(function () { return originalReplace.apply(void 0, __spread(args)); }, target, 'replace');
    };
    return function () {
        history.push = originalPush;
        history.replace = originalReplace;
        delete history.__fmpNavigationGuardInstalled;
        hideNavigationHint();
        _pendingNavigation = null;
    };
}
var DEFERRED_RETRY_DELAYS = [1000, 3000];
export function wait(delay) {
    return new Promise(function (resolve) { return setTimeout(resolve, delay); });
}
